/* FENN: herói com dois vídeos toca um DEPOIS do outro (igual ao layout offline: moto, depois o
 * outro, e repete), em vez de mostrar os dois lado a lado ("tela dividida"), que é o que o tema
 * Horizon faz quando os dois espaços de mídia do herói têm vídeo.
 * Regra de configuração: no herói, Mídia 1 = primeiro vídeo, Mídia 2 = segundo vídeo. Este script
 * esconde o segundo, tira o "loop" dos dois e alterna: quando um termina, mostra o outro do início.
 * Se o script não rodar, o tema mostra os dois lado a lado (nunca fica em branco). */
(function () {
  function iniciar() {
    document.querySelectorAll('.hero__media-grid').forEach(function (grid) {
      if (grid.dataset.fennSequencia) return;
      var wrappers = Array.prototype.filter.call(grid.querySelectorAll('.hero__media-wrapper'), function (wr) {
        return wr.querySelector('video') && getComputedStyle(wr).display !== 'none';
      });
      if (wrappers.length < 2) return;
      grid.dataset.fennSequencia = '1';
      grid.classList.add('fenn-hero-sequencia');
      grid.style.setProperty('--hero-media-count', '1');
      grid.style.setProperty('--hero-media-count-mobile', '1');
      var videos = wrappers.map(function (wr) { return wr.querySelector('video'); });
      videos.forEach(function (v) { v.removeAttribute('loop'); v.loop = false; v.muted = true; v.playsInline = true; });
      function mostrar(i) {
        wrappers.forEach(function (wr, k) { wr.classList.toggle('fenn-hero-oculto', k !== i); });
        videos.forEach(function (v, k) {
          if (k === i) {
            try { v.currentTime = 0; } catch (e) {}
            var p = v.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }
      videos.forEach(function (v, i) {
        v.addEventListener('ended', function () { mostrar((i + 1) % videos.length); });
      });
      mostrar(0);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
